import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { Box } from '@mui/material';

const AnimatedClockIcon = ({ size = 32, color = "#FFA500" }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: size,
        height: size,
        display: 'inline-block',
      }}
    >
      {/* Base Clock Icon */}
      <AiOutlineClockCircle size={size} color={color} />

      {/* Spinning Clock Hand */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '49%',
          width: '2px',
          height: '35%',
          backgroundColor: color,
          transformOrigin: 'bottom center',
          animation: 'spin 8s linear infinite',
          borderRadius: '1px',
        }}
      />
      {/* Inline CSS animation */}
      <style>
        {`
          @keyframes spin {
            0%   { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default AnimatedClockIcon;
